import React, { type ComponentType, PureComponent } from 'react';

import AppConfigContext from './AppConfigContext';
import { type AppConfigProviderState, type InjectedDocumentTitleProps } from './types';

export default function withDocumentTitleHOC<P extends object>(
	WrappedComponent: ComponentType<P & InjectedDocumentTitleProps>,
): ComponentType<P> {
	const nameOfWrapperComponent =
		WrappedComponent.displayName || WrappedComponent.name || 'Component';

	// eslint-disable-next-line @repo/internal/react/no-class-components
	class WithDocumentTitleComponent extends PureComponent<P> {
		static displayName = `withDocumentTitleHOC(${nameOfWrapperComponent})`;

		render() {
			const wrappedComponentProps: P = this.props;

			return (
				<AppConfigContext.Consumer>
					{({ docTitle }: AppConfigProviderState) => (
						<WrappedComponent {...wrappedComponentProps} docTitle={docTitle} />
					)}
				</AppConfigContext.Consumer>
			);
		}
	}

	return WithDocumentTitleComponent;
}
